import PRICING_TABLE_DATA from './pricing-page-table-data';

interface IRFData {
  id: number;
  type: string;
  values: any[];
}

const RFData: IRFData[] = [
  {
    id: 1,
    type: 'PAY AS YOU GO',
    values: [],
  },
  {
    id: 2,
    type: 'MEASURE',
    values: [],
  },
  {
    id: 3,
    type: 'SCALE',
    values: [],
  },
  {
    id: 4,
    type: 'TRANSFORM',
    values: [],
  },
];

PRICING_TABLE_DATA.forEach(section => {
  section.features.forEach(feature => {
    feature.values.forEach((value, index) => RFData[index].values.push(value));
  });
});

export default RFData;
